import React from "react";
import { FieldLabel, FieldValue, TextField } from "@td/ui";
import { fieldTypes } from "../constants";
import { translate } from "@td/shared_utils";

const NewPatientsDailyLimitField = React.memo(() => (
  <FieldLabel>
    <div>
      {translate(null, "provider_panel.form.fields.new_patients_daily_limit", "label")}
    </div>

    <FieldValue>
      {translate(null, "provider_panel.form.fields.new_patients_daily_limit", "note")}
    </FieldValue>

    <TextField
      autoComplete="off"
      name={fieldTypes.NEW_PATIENTS_DAILY_LIMIT}
      placeholder={translate(null, "provider_panel.form.fields.new_patients_daily_limit", "placeholder")}
    />
  </FieldLabel>
));

NewPatientsDailyLimitField.displayName = "NewPatientsDailyLimitField";

export default NewPatientsDailyLimitField;
